module.exports = __webpack_public_path__ + "img/crew_upgrade4_7-7-2021.caf376b4.jpg";